jQuery.fn.exists = function() {
  return this.length > 0;
};
